import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {INPUT_LINE_HEIGHT} from 'styles/StyleConstants';

interface ListingToolbarAreaProps {
  children: React.ReactNode;
}

/**
 * Wrapper component that applies style to the SelectedRowsCounter & corresponding Toolbar in an expanded search
 */
export default function ListingToolbarArea(props: ListingToolbarAreaProps): JSX.Element | null {
  return <div className={css(listingToolbarAreaStyle.headerRow)}>{props.children}</div>;
}

const listingToolbarAreaStyle = StyleSheet.create({
  headerRow: {
    ...INPUT_LINE_HEIGHT,
    display: 'flex',
    gap: '20px',
  },
});
